// Skills

export const SKILLS = {
  // Programming Languages
  JavaScript: 'JavaScript',
  TypeScript: 'TypeScript',
  Python: 'Python',
  Java: 'Java',
  'C#': 'C#',
  PHP: 'PHP',
  SQL: 'SQL',
  HTML: 'HTML',
  CSS: 'CSS',
  SCSS: 'SCSS',

  // Frameworks & Libraries
  React: 'React',
  Angular: 'Angular',
  'Vue.js': 'Vue.js',
  'Node.js': 'Node.js',
  'Express.js': 'Express.js',
  'Next.js': 'Next.js',
  Redux: 'Redux',
  Bootstrap: 'Bootstrap',
  'Material-UI': 'Material-UI',
  'Tailwind CSS': 'Tailwind CSS',

  // Databases
  MongoDB: 'MongoDB',
  PostgreSQL: 'PostgreSQL',
  MySQL: 'MySQL',
  Redis: 'Redis',
  Firebase: 'Firebase',

  // DevOps & Tools
  Docker: 'Docker',
  Kubernetes: 'Kubernetes',
  Git: 'Git',
  GitHub: 'GitHub',
  GitLab: 'GitLab',
  Jenkins: 'Jenkins',
  AWS: 'AWS',
  Azure: 'Azure',
  'Google Cloud': 'Google Cloud',

  // Machine Learning & AI
  TensorFlow: 'TensorFlow',
  PyTorch: 'PyTorch',
  'Scikit-learn': 'Scikit-learn',
  Pandas: 'Pandas',
  NumPy: 'NumPy',
  Matplotlib: 'Matplotlib',
  OpenCV: 'OpenCV',

  // Other
  'REST API': 'API REST',
  GraphQL: 'GraphQL',
  Microservices: 'Microservices',
  Agile: 'Agile',
  Scrum: 'Scrum',
  'CI/CD': 'CI/CD',
  Testing: 'Tests',
  Jest: 'Jest',
  Cypress: 'Cypress',
} as const;
